module.exports = __webpack_public_path__ + "static/media/icon7.13045ea0.svg";